import { createContext, useContext } from 'react';

export const AccessibilityReviewContext = createContext(null);

export const useAccessibilityReview = () => useContext(AccessibilityReviewContext);
